import useNavModel, { RouterParamType } from '@/model/navModel'
import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'antd'
import { Mavb } from './mavb'
import { Contrast } from './contrast'
import { useInquiryResultDetailModel } from './inquiryResultDetail'
export default () => {
    const { getSelectedNavState } = useNavModel(() => [])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { getDetail, mainData, oneData, twoData } = useInquiryResultDetailModel()

    useEffect(() => {
        getDetail(detailsInfo.id)
    }, [detailsInfo.id])
    return (
        <>
            {detailsInfo && (
                <>
                    <div className="flex justify-center" style={{ width: 'calc(100vw - 255px)' }}>
                        <Mavb {...detailsInfo} data={mainData} className="flex-1" />
                        <Contrast {...detailsInfo} data={oneData} type="one" className="flex-1" />
                        <Contrast {...detailsInfo} data={twoData} type="two" className="flex-1" />
                    </div>
                </>
            )}
        </>
    )
}
